import React from 'react'
import { TrendingNewsIcon } from '@news-mono/component-library'
import { layout } from '../../App.routing'

export const trendingArticlesSegment = () => {
    return layout.nestedComposition({
        type: 'box',
        props: {},
        feature: 'show-trending-articles',
        contentAreas: {
            main: [
                layout.component({
                    type: 'tn-article-cards',
                    props: {
                        sectionHeading: 'Trending',
                        icon: { IconElement: <TrendingNewsIcon /> },
                        dataDefinitionArgs: {
                            type: 'curation',
                            name: 'trending-articles',
                            offset: 0,
                            pageSize: 4,
                            excludeCurations: ['top-stories'],
                            excludeSources: ['Daily Mail', 'PerthNow'],
                            applyTrendingStoriesExclusion: true,
                        },
                    },
                }),
            ],
        },
    })
}
